import { colorsForUser, initialsFor } from '../lib/avatar';

interface Props {
  userId: string;
  name: string;
  size?: number;
  ring?: boolean;
}

export function Avatar({ userId, name, size = 36, ring }: Props) {
  const { bg, fg } = colorsForUser(userId);
  const initials = initialsFor(name);
  return (
    <div
      style={{
        width: size,
        height: size,
        background: bg,
        color: fg,
        fontSize: Math.round(size * 0.42),
      }}
      className={`shrink-0 rounded-full flex items-center justify-center font-semibold select-none ${ring ? 'ring-2 ring-white shadow-sm' : ''}`}
      title={name}
    >
      {initials}
    </div>
  );
}
